<template>
  <!-- 删除监控 -->
  <div class="delMonitorWrapper">
    <div class="delMonitor">
      <!-- 头部查询表单 -->
      <div class="headForm">
        <div class="headTips">
          <div class="leftFlex">
            <h4 style="color: #2e3458; font-size: 16px; font-weight: bold">
              删评监控
            </h4>
            <span class="desc"
              >每天更新监控商品在京东商品页面的评价删除情况</span
            >
          </div>
          <div class="rightFlex">
            <span>最近监控时间：{{ this.currentdate }}</span>
            <button class="updateBtn" :disabled="uploadLoading" @click="update">刷新</button>
          </div>
        </div>
        <div style="padding-top: 20px">
          <inputForm
            :inputData="inputData"
            @toParentVal="queryList"
            :btnPosition1="true"
            ref="searchForm"
          ></inputForm>
        </div>
      </div>

      <!-- 内容部分 -->
      <div class="content">
        <!-- 按钮区块 -->
        <div class="titBtns">
          <button class="newAddBtn" v-zoom='{from:pageName,name:"添加监控"}' @click.prevent="selectGoodsIsShow = true">
            <img
              src="@/assets/images/member/new_establish.png"
              style="
                display: inline-block;
                float: left;
                width: 14px;
                height: 14px;
                color: #ffffff;
                margin: 0px 4px 0px 0px;
              "
            />
            添加监控
          </button>
          <p>
            共
            <span style="color: #fe4d45">200</span> 个监控位，已用
            <span style="color: #fe4d45">{{ total }}</span> 个
          </p>
        </div>

        <!-- 表格 -->
        <el-table
          :data="tableData"
          v-loading="loading"
          :header-cell-style="{ background: '#fafafa','text-align':'left' }"
            :cell-style="{'text-align':'left'}"
          style="width: 100%"
        >
            <template slot="empty">
              <div>
                <img src="@/assets/images/default/暂无任何数据.png" />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
          <el-table-column label="商品信息" width="500">
            <template slot-scope="scope">
              <div class="shopInfo" v-zoom='{from:pageName,name:"商品跳转"}' @click="routerJump(scope.row.itemURL)">
                <img :src="scope.row.logo" class="avar" alt />
                <div class="descBox">
                  <span class="tit">{{ scope.row.wareTitle }}</span>
                  <span class="shopId">商品编码：{{ scope.row.wareId }}</span>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="评价总数（新增/删除）">
            <template slot-scope="scope" v-if="scope.row.isCounted !== 0">
              <span>{{ scope.row.totalCommentNum }}</span>
              <span>(+{{ scope.row.addCommentNum }}/</span>
              <span>-{{ scope.row.deleteCommentNum }})</span>
            </template>
          </el-table-column>
          <el-table-column prop="favorable" label="好评（新增/删除）">
            <template slot-scope="scope" v-if="scope.row.isCounted !== 0">
              <span>{{ scope.row.goodCommentNum }}</span>
              <span>(+{{ scope.row.addGoodCommentNum }}/</span>
              <span>-{{ scope.row.deleteGoodCommentNum }})</span>
            </template>
          </el-table-column>
          <el-table-column prop="middleEvaluation" label="中评（新增/删除）">
            <template slot-scope="scope">
              <div v-if="scope.row.isCounted === 0">正在更新中</div>
              <div v-else>
                <span>{{ scope.row.middleCommentNum }}</span>
                <span>(+{{ scope.row.addMiddleCommentNum }}/</span>
                <span>-{{ scope.row.deleteMiddleCommentNum }})</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="差评（新增/删除）">
            <template slot-scope="scope" v-if="scope.row.isCounted !== 0">
              <span>{{ scope.row.badCommentNum }}</span>
              <span>(+{{ scope.row.addBadCommentNum }}/</span>
              <span>-{{ scope.row.deleteBadCommentNum }})</span>
            </template>
          </el-table-column>
          <el-table-column label="好评率">
            <template slot-scope="scope" v-if="scope.row.isCounted !== 0">
              <span>{{ scope.row.goodCommentRate }}%</span>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="170px">
            <template slot-scope="scope">
              <div class="hendle">
                <span class="operation" v-zoom='{from:pageName,name:"查看评价"}' @click="viewComments(scope.row.wareId)"
                  >查看评价</span
                >
                <span class="operation" v-zoom='{from:pageName,name:"取消监控"}' @click="cancelMonitor(scope.row.wareId)"
                  >取消监控</span
                >
              </div>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <el-pagination
          @size-change="handleSizeChange"
          background
          @current-change="handleCurrentChange"
          :page-sizes="[10, 30, 50, 100]"
          :page-size="size"
          layout="total, sizes, prev, pager, next, jumper"
          class="pagination"
          :total="total"
        ></el-pagination>
      </div>
    </div>

    <!-- 添加监控组件 -->
    <select-goods-monitor
      :skuSearch="venderType"
      v-show="selectGoodsIsShow"
      :moduleType="true"
      :isShow="selectGoodsIsShow"
      @close="selectGoodsChange"
    ></select-goods-monitor>
    <!-- 查看评价弹窗 -->
    <my-popup
      title="评价列表"
      width="1126"
      :flag="lookComments"
      @close="viewCommentsClose"
      :z-index="'100'"
    >
      <div class="commentsWrapper">
        <!-- 头部选项卡 -->
        <div class="navList">
          <span :class="{ active: navIsAcitev == -1 }" @click="navSwitch(-1)"
            >被删评论</span
          >
          <span :class="{ active: navIsAcitev == 1 }" @click="navSwitch(1)"
            >新增评论</span
          >
          <div class="line"></div>
        </div>
        <!-- 表单查询 -->
        <inputForm
          :inputData="commentsInputData"
          @toParentVal="commentsSearchForm"
          :time="commentType"
          ref="commentsForm"
        ></inputForm>

        <!-- 评论列表 -->
        <table
          class="commentsList"
          cellpadding="0"
          cellspacing="0"
          v-loading="commentsLoading"
        >
          <tr class="thead">
            <th class="seize"></th>
            <th style="flex: 1">评价日期</th>
            <th style="flex: 1">SKU ID</th>
            <th style="flex: 1">评分等级</th>
            <th style="flex: 3">买家评价</th>
          </tr>
          <tr
            class="tbody"
            v-for="(item, index) in commentsList"
            :key="'comments' + index"
          >
            <td class="seize"></td>
            <td style="flex: 1">{{ item.creationTime }}</td>
            <td style="flex: 1">{{ item.skuId }}</td>
            <td style="flex: 1" class="star">
              <star :key="item.skuId" :score="item.score"></star>
              <span class="txt">{{ item.score }}星</span>
            </td>
            <td class="desc" style="flex: 3">
              <span>{{ item.content }}</span>
            </td>
          </tr>
        </table>

        <!-- 分页 -->
        <el-pagination
          @size-change="handleCommentsSizeChange"
          @current-change="handleCommentsCurrentChange"
          :page-sizes="[10, 30, 50, 100]"
          :page-size="commentsSize"
          :current-page="commentsCurrent"
          layout="total, sizes, prev, pager, next, jumper"
          class="pagination"
          :total="commentsTotal"
        ></el-pagination>

        <!-- 底部按钮 -->
        <div class="footBtns">
          <button class="cancel" @click="viewCommentsClose">取消</button>
          <button class="confirm" @click="viewCommentsClose">确认</button>
        </div>
      </div>
    </my-popup>
  </div>
</template>

<script>
import inputForm from "@/components/inputForm";
import selectGoodsMonitor from "@/components/selectGoodsMonitor";
import myPopup from "@/components/myPopup";
import star from "@/components/star";
import {
  getMonitorList,
  addWareMonitor,
  wareList,
  cancelMonitor,
  wareComment, 
  refreshMonitor,
} from "@/api/serviceCenter/deleteCommentListener";

export default {
  components: {
    inputForm,
    selectGoodsMonitor,
    myPopup,
    star,
  },
  data() {
    return {
      // 查询表单配置项
      pageName:"售后中心-删除监控",
      inputData: [
        {
          name: "查询日期:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault:true,
        },
        {
          name: "商品编码:",
          placeholder: "请输入商品编码",
          val: "wareId",
        },
        {
          name: "SKU ID:",
          placeholder: "请输入SKU ID",
          val: "skuId",
        },
      ],
      time: "",
      // 表格数据
      tableData: [],
      loading: false,
      // 分页配置
      current: 1,
      size: 10,
      total: 0,
      // 添加监控组件状态控制
      selectGoodsIsShow: false,
      // 查看评价导航控制
      navIsAcitev: -1,
      // 查看评价弹窗状态控制
      lookComments: false,
      // 查看评价表单查询配置项
      commentType: 2,
      commentsInputData: [
        {
          name: "评价日期:",
          myDate: true,
          val: ["creationTimeStart", "creationTimeEnd"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "SKU ID:",
          val: "skuId",
          placeholder: "请输入...",
        },
        {
          name: "评分等级:",
          val: "score",
          selectArr: [
            { label: "一星", id: 1 },
            { label: "二星", id: 2 },
            { label: "三星", id: 3 },
            { label: "四星", id: 4 },
            { label: "五星", id: 5 },
          ],
          width: 136,
        },
      ],
      // 查看评价分页配置
      commentsSize: 10,
      currentdate: "",
      commentsCurrent: 1,
      commentsTotal: 0,
      // 查看评价评论列表  --- 被删评论、新增评论
      commentsList: [],
      // 查看评价评论列表当前页
      currenCommentstPage: 1,
      commentsLoading: false,
      // 当前查看评价的wareId
      curWareId: 0,
      uploadLoading: false,
    };
  },
  created() {
    // 埋点
    this.buriedPoint(1, '删评数据监控', '数据分析', '评价分析')
  },
  mounted() {
    this.$refs.searchForm.submitForm("formSearch");
    // this.dateFormat();
  },
  computed: {
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
  },
  methods: {
    //获得当前时间
    dateFormat() {
      var date = new Date();
      console.log(date);
      var seperator1 = "-";
      var seperator2 = " ";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      var hours =
        date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      var minutes =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      var seconds =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate =
        year +
        seperator1 +
        month +
        seperator1 +
        strDate +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds;
      this.currentdate = currentdate;

      this.$refs.searchForm.submitForm("formSearch");
    },
    /**
     * 表单查询
     */
    queryList(form, state) {
      this.loading = true;
      form.current = state ? 1 : this.current;
      form.size = this.size;
      getMonitorList(form).then((res) => {
        this.tableData = res && res.data.records;
        this.total = res && res.data.total;
        this.loading = false;

        console.log(this.tableData);
      });
    },
    // 取消商品监控
    cancelMonitor(wareId) {
      this.$confirm("是否确定取消商品监控?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass: "iconfont iconicon-jinggao1",
      })
        .then(() => {
          cancelMonitor({ wareId }).then((res) => {
            if (res.code == 1) {
              this.$message.success("取消成功");
              this.$refs.searchForm.submitForm("formSearch");
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 查看评价
    viewComments(wareId) {
      this.curWareId = wareId;
      this.commentsCurrent = 1;
      this.commentsSize = 10;
      this.$refs.commentsForm.submitForm("formSearch");
      this.lookComments = true;
    },
    // 评价弹窗tab切换
    navSwitch(val) {
      if (this.navIsAcitev == val) return;
      this.navIsAcitev = val;
      this.$refs.commentsForm.submitForm("formSearch");
    },
    // 刷新
    update() {
      if (this.tableData.length <= 0) return;
      this.$refs.searchForm.submitForm("formSearch");
      this.dateFormat();
      // this.uploadLoading = true;
      // refreshMonitor().then((res) => {
      //   this.uploadLoading = false;
      //   this.currentdate = res.data.monitorUpdateTime;
      //   this.$message.success("刷新成功");
      //   this.$refs.searchForm.submitForm("formSearch");
      // });
    },
    // 商品跳转
    routerJump(link) {
      if (!link) return;
      console.log(link);
      // return;
      window.open(link);
    },
    /**
     * 分页事件
     */
    handleSizeChange(val) {
      this.size = val;
      this.current = 1;
      this.$refs.searchForm.submitForm("formSearch");
    },
    handleCurrentChange(val) {
      this.current = val;
      this.$refs.searchForm.submitForm("formSearch");
    },
    /**
     * 添加监控组件隐藏
     */
    selectGoodsChange(data) {
      console.log(data);
      if (data && data.length > 0) {
        addWareMonitor(data).then((res) => {
          if (res && res.code == 1) {
            this.$refs.searchForm.submitForm("formSearch");
            this.$message.success("添加成功");
          }
        });
      }
      this.selectGoodsIsShow = false;
    },
    /**
     * 查看评价隐藏
     */
    viewCommentsClose() {
      this.lookComments = false;
    },
    /**
     * 查看评价弹窗表单查询
     */
    commentsSearchForm(form) {
      this.commentsLoading = true;
      form.current = this.commentsCurrent;
      form.size = this.commentsSize;
      form.popCommentStatus = this.navIsAcitev;
      form.wareId = this.curWareId;
      wareComment(form).then((res) => {
        if (res && res.code == 1) {
          this.commentsList = res && res.data.records;
          // this.commentsCurrent = res && res.data.current;
          this.commentsTotal = res && res.data.total;
          this.commentsLoading = false;
        }
      });
    },
    /**
     * 查看评价分页事件
     */
    handleCommentsSizeChange(val) {
      this.commentsSize = val;
      this.commentsCurrent = 1;
      this.$refs.commentsForm.submitForm("formSearch");
    },
    handleCommentsCurrentChange(val) {
      this.commentsCurrent = val;
      this.$refs.commentsForm.submitForm("formSearch");
    },
  },
};
</script>

<style lang="scss" scoped>
button {
  margin: 0;
  padding: 0 12px;
  height: 32px;
  line-height: 30px;
  border: none;
  outline: none;
  border-radius: 3px;
  background-color: #fff;
  cursor: pointer;
  transition: all 0.2s;
}
.delMonitor {
  box-sizing: border-box;
  padding: 20px;
  min-width: 1100px;
  .headForm {
    box-sizing: border-box;
    background: white;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    .headTips {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 54px;
      padding: 0 28px;
      border-bottom: 1px solid #f0f0f0;
      .leftFlex,
      .rightFlex {
        display: flex;
        align-items: center;
      }
      h4 {
        margin: 0 12px 0 0;
        color: #2e3458;
        font-size: 16px;
      }
      .desc {
        color: #fe4d45;
        font-size: 14px;
      }
      .updateBtn {
        margin-left: 12px;
        width: 96px;
        height: 28px;
        line-height: 26px;
        border: 1px solid #ddd;
        color: #666;
        font-size: 14px;
        &:hover {
          border: 1px solid #fe4d45;
          color: #fe4d45;
          background-color: #fff4f4;
        }
      }
    }
  }
  .content {
    box-sizing: border-box;
    padding: 24px 28px 30px;
    margin-top: 20px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    .titBtns {
      display: flex;
      align-items: center;
      color: #333;
      font-size: 14px;
      font-weight: 400;
      margin-bottom: 20px;
      .newAddBtn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 98px;
        color: #fff;
        margin-right: 12px;
        background-color: #fe4d45;
        &:hover {
          color: #fff;
          opacity: 0.9;
          background-color: #fe4d45;
        }
        .newAdd {
          width: 14px;
          height: 14px;
          margin: 0 4px 2px 0;
        }
      }
    }
    .shopInfo {
      display: flex;
      align-items: center;
      height: 100px;
      &:hover {
        text-decoration: underline;
      }
      .avar {
        flex-shrink: 0;
        width: 58px;
        height: 58px;
        margin-right: 16px;
        border-radius: 50%;
        background-color: #f6f6f6;
      }
      .descBox {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        color: #333;
        font-size: 14px;
        font-weight: 400;
        .tit {
          line-height: 20px;
          width: 90%;
        }
        .shopId {
          color: #999;
        }
      }
    }
    .hendle {
      display: flex;
      align-items: center;
      .operation {
        cursor: pointer;
        color: #7f85e9;
        &:hover {
          color: #fe4d45;
        }
      }
      span {
        cursor: pointer;
        margin-right: 20px;
        font-size: 14px;
        &:last-child {
          margin: 0;
        }
      }
    }
    .pagination {
      margin-top: 20px;
      text-align: right;
    }
  }
}
.commentsWrapper {
  box-sizing: border-box;
  .navList {
    display: flex;
    align-items: flex-end;
    width: 100%;
    height: 35px;
    margin: 20px 0;
    span {
      flex-shrink: 0;
      width: 106px;
      height: 35px;
      line-height: 34px;
      text-align: center;
      margin-right: 2px;
      border: 1px solid rgba(221, 221, 221, 1);
      border-radius: 2px 2px 0px 0px;
      cursor: pointer;
      &:last-child {
        margin: 0;
      }
    }
    .active {
      border-bottom: none !important;
      border-top: 2px solid #fe4d45;
      border-radius: 4px 4px 0px 0px;
    }
    .line {
      flex: 1;
      border-bottom: 1px solid #ddd;
    }
  }
  .commentsList {
    display: inline-block;
    width: 100%;
    height: 243px;
    overflow: auto;
    margin-top: 20px;
    text-align: left;
    border-collapse: collapse;
    font-size: 14px;
    &::-webkit-scrollbar {
      width: 8px;
      height: 10px;
    }
    &::-webkit-scrollbar-track {
      background: rgba(246, 246, 246, 1);
      border-radius: 2px;
    }
    &::-webkit-scrollbar-thumb {
      background: #ddd;
      border-radius: 10px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: #ddd;
    }
    .seize {
      width: 20px;
    }
    .thead {
      display: flex;
      align-items: center;
      height: 40px;
      line-height: 38px;
      border: 1px solid rgba(243, 243, 243, 1);
      box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.04);
    }
    .tbody {
      display: flex;
      align-items: center;
      width: 100%;
      height: 60px;
      border: 1px solid #f3f3f3;
      border-top: none;
      .star {
        display: flex;
        align-items: center;
        .txt {
          margin-left: 16px;
          color: #999;
        }
      }
      .desc {
        span {
          width: 90%;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          overflow: hidden;
        }
      }
    }
  }
  .pagination {
    margin-top: 20px;
    text-align: right;
  }
  .footBtns {
    margin-top: 30px;
    text-align: right;
    .cancel {
      width: 98px;
      margin-right: 12px;
      border: 1px solid rgba(204, 204, 204, 1);
      color: #999;
    }
    .confirm {
      width: 98px;
      background: rgba(254, 77, 69, 1);
      color: #fff;
    }
  }
}
</style>
